import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Box, CircularProgress } from "@mui/material";

import { CommonDialog, CommonDialogContent, CommonDialogTitle } from "../../../common/dialogs";

import "./styles.less";
import { useDispatch } from "react-redux";
import { AppDispatch, RootState } from "../../../../store";
import { useSelector } from "react-redux";
import { SelectInput } from "../../../common/form-controls";
import { MenuItem } from "../../../common/menu";
import { Button } from "../../../common/buttons";
import { fetchRequestDetailed, setRequestStage } from "../../../../reducers/administration/requestSlice";
type SetRequestStageDialogProps = {
    open: boolean;
    onClose: () => void;
};

type requestStage = {
    text: string;
    stage: string;
};
const SetRequestStageDialog: React.FC<SetRequestStageDialogProps> = ({ open, onClose }) => {
    const intl = useIntl();
    const dispatch = useDispatch<AppDispatch>();
    const stages = useSelector((state: RootState) => state.administration.requests.requestStages);
    const currentRequest = useSelector((state: RootState) => state.administration.requests.currentRequest);
    const [selectedStage, setSelectedStage] = useState("");
    // const validationErrors = useSelector((state: RootState) => state.administration.requests.validationErrors);
    const title = intl.formatMessage({ id: "set-request-stage-dialog.title" });
    const busy = useSelector((state: RootState) => state.administration.requests.busy);

    useEffect(() => {
        if (currentRequest?.currentStage) setSelectedStage(currentRequest?.currentStage);
    }, [currentRequest]);

    const onSaveClick = async () => {
        if (currentRequest) {
            await dispatch(setRequestStage({ requestId: currentRequest?.requestId, stage: selectedStage })).unwrap()

            dispatch(fetchRequestDetailed({requestId: currentRequest?.requestId}));

            onClose();
        }
    };

    return (
        <>
            <CommonDialog className="create-request-dialog" open={open}>
                <CommonDialogTitle title={title} onClose={onClose} withoutCloseIcon={false} />
                <CommonDialogContent>
                    {busy && <CircularProgress className="report-columns-dialog-circular-progress" size={32} />}
                    <SelectInput value={selectedStage} onChange={(event) => setSelectedStage(event.target.value)}>
                        {stages.map((item: requestStage) => (
                            <MenuItem key={item.stage} value={item.stage} sx={{ minHeight: "initial", height: "36px" }}>
                                {item.text}
                            </MenuItem>
                        ))}
                    </SelectInput>
                    <Box gap={2} sx={{ marginTop: "15px" }} justifyContent="flex-end" display="flex">
                        <Button
                            disabled={false}
                            variant="outlined"
                            onClick={onClose}
                            sx={{
                                color: "var(--font-4)",
                                borderColor: "var(--font-4)",
                            }}
                        >
                            <FormattedMessage id="common.btn-cancel" />
                        </Button>
                        <Button
                            variant="contained"
                            sx={{
                                color: "var(--bg-2)",
                                backgroundColor: "var(--font-2)",
                                "&:hover": {
                                    backgroundColor: "var(--font-2)",
                                },
                            }}
                            onClick={onSaveClick}
                        >
                            <FormattedMessage id="common.btn-save" />
                        </Button>
                    </Box>
                </CommonDialogContent>
            </CommonDialog>
        </>
    );
};

export default SetRequestStageDialog;
